const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.SIZE_MATRICES)

export const apiSizeMatrices = {
	fetchDietSizeMatrices: async (): Promise<IDietSizeMatriceModel[]> => {
		const { data } = await apiCommon<IDietSizeMatrice[]>(`${groupPrefix}`, { method: 'GET' })

		return data.map(d => DietSizeMatrices(d))
	},
	updateDietSizeMatrices: async (body: IDietSizeMatricesPayload[]): Promise<void> => {
		await apiCommon<IDietSizeMatrice[]>(`${groupPrefix}`, { method: 'POST', body: { matrices: body } })
	},
}
